import Vue from "vue";
import Router from "vue-router";
// import store from "@/store";
Vue.use(Router);
const routes = [
  {
    path: "/login",
    component: () => import("@/views/login"), //组件地址
    children: [],
    name:'登录',
  },
  {
    path: "/",
    component: () => import("@/views/home"), //组件地址
    children: [],
    name:'首页',
  },
  {
    path: "/homeList",
    component: () => import("@/views/homeList"), //组件地址
    children: [],
    name:'产品动态列表',
  },
  {
    path: "/homeListDetail",
    component: () => import("@/views/homeListDetail"), //组件地址
    children: [],
    name:'产品动态详情',
  },
  {
    path:'/colony',
    component:()=>import('@/views/colony'),
    children:[],
    name:'集群介绍',
  },
  {
    path:'/news',
    component:()=>import('@/views/news'),
    children:[],
    name:'新闻资讯',
  },{
    path:'/policy',
    component:()=>import('@/views/policy'),
    children:[],
    name:'政策法规',
  },
  {
    path:'/enterprise',
    component:()=>import('@/views/enterprise'),
    children:[],
    name:'企业名录',
  },{
    path:'/enterpriseDetail',
    component:()=>import('@/views/enterpriseDetail'),
    children:[],
    name:'企业整机详情',
  },{
    path:'/enterDetailaccessory',
    component:()=>import('@/views/enterDetailaccessory'),
    children:[],
    name:'企业配件详情',
  },
  {
    path:'/companyInfo',
    component:()=>import('@/views/companyInfo/companyInfo'),
    children:[],
    name:'企业信息管理'
  },{
    path:'/nqi',
    component:()=>import('@/views/nqi'),
    children:[],
    name:'NQI服务',
  },{
    path:'/lift',
    component:()=>import('@/views/lift'),
    children:[],
    name:'电梯协会',
  },{
    path:'/liftDetail',
    component:()=>import('@/views/liftDetail'),
    children:[],
    name:'章程条例',
  },{
    path:'/related',
    component:()=>import('@/views/related'),
    children:[],
    name:'网站相关',
  },{
    path:'/register',
    component:()=>import('@/views/register'),
    children:[],
    name:'会员注册',
  }
  ,{
    path:'/map',
    component:()=>import('@/views/map'),
    children:[],
    name:'网站地图',
  }
  ,{
    path:'/piece',
    component:()=>import('@/views/piecePart/piece'),
    children:[],
    name:'整件',
  }
  ,{
    path:'/part',
    component:()=>import('@/views/piecePart/part'),
    children:[],
    name:'部件',
  }
  
  
];
// Router.afterEach(() => {

//   window.scrollTo(0, 0)

// });
const router = new Router({
  routes,
});
// router.beforeEach((to, from, next) => {    
//   // chrome
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0
//   next()
// })
export default router;
